import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import ElementUI from 'element-ui'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueClipboard from 'vue-clipboard2'
import login from '@/components/common/login/index'
import 'element-ui/lib/theme-chalk/index.css'

import { EpetJs } from '@/utils/epetsdk'
Vue.component('VuePerfectScrollbar', VuePerfectScrollbar)
Vue.component('login', login)
window.Bus = new Vue();

Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.prototype.$EpetJs = EpetJs;
Vue.directive('loadmore', {
    bind(el, binding) {
        const selectWrap = el.querySelector('.el-scrollbar__wrap')
        selectWrap.addEventListener('scroll', function () {
            let sign = 100
            const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
            if (scrollDistance <= sign) {
                binding.value()
            }
        })
    }
})
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
